import posthog from "posthog-js";

/** Tracks whether the user accepted or declined the terms & policy consent during onboarding. */
export const trackConsentChoice = (accepted: boolean) => {
  posthog.capture("onboarding_user_consent_completed", { accepted });
};

/** Tracks the user's cookie preference selection from the cookie consent dialog. */
export const trackCookieChoice = (choice: "all" | "essential" | "reject") => {
  posthog.capture("onboarding_cookie_choice", { cookie_consent: choice });
};

/** Tracks when the create case dialog is opened. */
export const trackCreateCaseDialogOpened = () => {
  posthog.capture("create_case_dialog_opened");
};

/** Tracks the number of cases sent for processing. */
export const trackCasesProcessed = (caseCount: number) => {
  posthog.capture("cases_processed", { case_count: caseCount });
};

/** Tracks a case download, capturing the type of download and how many cases were included. */
export const trackCaseDownloaded = (downloadType: "scan" | "based-model", caseCount: number) => {
  posthog.capture("case_downloaded", { download_type: downloadType, case_count: caseCount });
};

export const trackCreditsPageRedirect = () => {
  posthog.capture("credits_page_redirect");
};
